import Vue from 'vue'
import ECharts from 'vue-echarts'
import { use } from 'echarts/core'

// 导入需要的图表类型
import {
  CanvasRenderer
} from 'echarts/renderers'
import {
  GaugeChart,
  RadarChart,
  BarChart
} from 'echarts/charts'
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GraphicComponent,
  GridComponent
} from 'echarts/components'

// 注册必要的组件
use([
  CanvasRenderer,
  GaugeChart,
  RadarChart,
  BarChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GraphicComponent,
  GridComponent
])

// 全局注册组件
Vue.component('v-chart', ECharts)

import App from './App.vue';
import router from './router';
import store from './store';

// 引入 Element UI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

// 按需导入 Vant 组件
import { Button, Cell, CellGroup, Field, Form, Toast, Dialog, Loading, NavBar } from 'vant';

// 注册 Element UI
Vue.use(ElementUI);

// 注册 Vant 组件
Vue.use(Button);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Field);
Vue.use(Form);
Vue.use(Toast);
Vue.use(Dialog);
Vue.use(Loading);
Vue.use(NavBar);

import './styles/global.css';

// 设置Vue配置
Vue.config.productionTip = false;

// 全局错误处理
Vue.config.errorHandler = (err, vm, info) => {
  console.error('Vue Error:', err, info);
};

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');